import React, { useEffect, useState } from 'react';
import { Collapse, Icon, Row, Input, Typography, Form, Modal } from 'antd';
import { Table, Button, Col, MasterDetailForm } from '@digital/ui';
import moment from 'moment';
import { DocuSignAssinantes, getAssinantes, salvarDocuSignId } from '@app/api/DocuSign';
import { dadosGeraisState, ordemCompraIdState, reloadState } from '../atoms';
import { parametrosSasState } from '@app/atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { RelatorioHomologacaoProps, concluirRH, getRelatorioHomologacao } from '@app/api/sas/relatorioHomologacao';
import { isObjEmpty, isObjNotEmpty } from '@app/helpers/objHelper';
import { isValidGuid } from '@app/helpers/geradorGuid';
import { Space, Visibility } from '@app/components';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
const { Panel } = Collapse;

interface Props {
    parteDoFluxo?: boolean,
}

const WidgetDocuSignRelatorio = ({ parteDoFluxo = false }: Props) => {
    const [dadosGerais, setDadosGerais] = useRecoilState(dadosGeraisState);
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const [reload, setReload] = useRecoilState(reloadState);
    const parametrosSas = useRecoilValue(parametrosSasState);

    const [reloadRelatorio, setReloadRelatorio] = useState<boolean>(false);
    const [url, setURL] = useState(window.location.href);
    const [dadosRelatorio, setDadosRelatorio] = useState<RelatorioHomologacaoProps>();

    const [envelopeId, setEnvelopeId] = useState<string>("");
    const [assinantes, setAssinantes] = useState<DocuSignAssinantes>();
    const [historicoEnvelopes, setHistoricosEnvelopes] = useState<any[]>();
    const [disableEnvelopeId, setDisableEnvelopeId] = useState(false);

    const { Search } = Input;
    const { Title } = Typography;

    
    const isFaturamentoDireto = dadosRelatorio && (dadosRelatorio.tipoOc === ETipoDemanda.FaturamentoDireto || dadosRelatorio.tipoOc === ETipoDemanda.AditivoFaturamentoDireto) ;

    const onReloadRelatorio = () => {
        setReloadRelatorio(!reloadRelatorio);
    };

    const getInfoRelatorio = (ocId: string) => {
        getRelatorioHomologacao(ocId).then(data => {
            if (data) {
                setDadosRelatorio(data);
            }
        });
    };

    useEffect(() => {
        if (window.location.href != url) {
            setURL(window.location.href);
            if (window.location.href.toLocaleLowerCase().includes("relhomologacao")) onReloadRelatorio();
        }
    })

    useEffect(() => {
        if (ordemCompraId) {
            getInfoRelatorio(ordemCompraId);
        }
    }, [ordemCompraId, reload, reloadRelatorio]);

    useEffect(() => {
        if (dadosGerais) {
            if (dadosGerais.docuSignId) {
                if (isValidGuid(dadosGerais.docuSignId)) {
                    setDisableEnvelopeId(true);
                    setEnvelopeId(dadosGerais.docuSignId);
                }
                consultaAssinantes(dadosGerais.docuSignId);
            }
        }
    }, [dadosGerais, reload]);

    const consultaAssinantes = (envelopeId: string) => {
        getAssinantes(envelopeId, ordemCompraId).then((data: any) => {
            if (data && data.recipients && data.recipients.signers) {
                setAssinantes(data.recipients.signers);
            }
            if (data && data.historico) {
                setHistoricosEnvelopes(data.historico);
            }
            if (data && data.reload) {
                onReload();
            }
        })
    }

    const onSearchEnvelopeId = () => {
        consultaAssinantes(envelopeId)
    }

    const onSalvarEnvelopeId = () => {
        var values = {
            envelopeId: envelopeId,
        }
        salvarDocuSignId(ordemCompraId, values).then((data: any) => {
            if (data && data.valid && values.envelopeId != "") {
                setDisableEnvelopeId(true);
                consultaAssinantes(values.envelopeId);
                onReload();
            }
        });
    }

    const onReload = () => {
        setReload(!reload);
    };

    const onClickAlterarId = () => {
        setDisableEnvelopeId(false);
        setEnvelopeId("");
    }

    const handleConcluirRH = () => {
        Modal.confirm({
            title: 'Concluir RH',
            content: `O RH assinado corresponde à OC ${dadosGerais.numero}?`,
            cancelText: 'Não',
            onCancel: () => { },
            okText: 'Sim',
            onOk: () => {
                concluirRH(ordemCompraId)
                    .then((data: any) => {
                        if (data && data.valid) {
                            onReload();
                        }
                    });
            },
        });
    }

    const columnsAssinante = [
        {
            title: "Nome",
            dataIndex: "name",
            width: "40%",
        },
        {
            title: "Email",
            dataIndex: "email",
            width: "20%",
        },
        {
            title: "Assinou",
            dataIndex: "status",
            width: "20%",
            render: (record: any) => {
                return record && record.includes('completed') ? 'Sim' : 'Não';
            }
        },
        {
            title: "Data Assinatura",
            dataIndex: "signedDateTime",
            width: "20%",
            render: (record: any) => {
                return moment(record).format("DD/MM/YYYY HH:mm");
            }
        }
    ];

    const columnsHistorico = [
        {
            title: "Envelope ID",
            dataIndex: "envelopeId",
        },
        {
            title: "Status",
            dataIndex: "status",
        }
    ]

    return (
        <Visibility
            visible={!isFaturamentoDireto && 
                dadosRelatorio && isObjNotEmpty(dadosRelatorio) &&
                (
                    (parametrosSas.sasValorMaximoGerenteGeralHabilitado === false
                        || dadosGerais.valorCalcRH > parametrosSas.sasValorMaximoGerenteGeral) &&
                    (parametrosSas.sasValorMaximoGerenteDepartamentoHabilitado === false
                        || dadosGerais.valorCalcRH > parametrosSas.sasValorMaximoGerenteDepartamento)
                )
            }
        >
            <Collapse
                bordered={false}
                defaultActiveKey="IntegracaoDocuSignRH"
                expandIcon={() => <Icon type="arrows-right_4" />}
            >
                <Panel
                    key="IntegracaoDocuSignRH"
                    header="Integração DocuSign – Relatório de Homologação "
                    showArrow={!parteDoFluxo}
                >
                    <MasterDetailForm
                        actions={[
                            <>
                                {dadosRelatorio && dadosRelatorio.aprovacaoDocusignStatus && dadosRelatorio.aprovacaoDocusignStatus.includes('Aprovado DocuSign') && disableEnvelopeId && (
                                    < Button type='primary' title='Concluir RH' onClick={handleConcluirRH} />
                                )}
                            </>,
                            <>
                                {dadosRelatorio && dadosRelatorio.aprovacaoDocusignStatus && disableEnvelopeId && (
                                    <Button type='primary' title='Alterar ID' onClick={onClickAlterarId} style={{ paddingLeft: '8px', marginLeft: '8px' }} />
                                )}
                            </>
                        ]}
                    >
                        <Title level={4}>
                            Envelope Id:
                        </Title>
                        <Row>
                            <Form.Item validateStatus={isObjEmpty(envelopeId) ? 'error' : ''} help={isObjEmpty(envelopeId) ? "Envelope Id é obrigatário." : ""} >
                                <Search
                                    style={{ margin: '5px', width: '25%', textAlign: 'justify' }}
                                    placeholder={'Envelope Id'} name={''}
                                    value={envelopeId}
                                    onChange={(e) => {
                                        setEnvelopeId(e.target.value);
                                    }}
                                    onSearch={(e) => {
                                        onSearchEnvelopeId();
                                    }}
                                    disabled={disableEnvelopeId}
                                />
                                <Button type="link" style={{ margin: '5px' }} onClick={onSalvarEnvelopeId}>Salvar</Button>
                            </Form.Item>
                        </Row>
                        <Title level={4}>
                            Assinantes
                        </Title>
                        <Table
                            style={{ marginTop: '5px' }}
                            dataSource={assinantes}
                            columns={columnsAssinante}
                            pagination={false}
                            rowKey="id"
                        />
                        <hr />
                        <Title level={4}>Histórico de Envelopes</Title>
                        <Col span={6}>
                            <Table
                                style={{ marginTop: '5px' }}
                                dataSource={historicoEnvelopes}
                                columns={columnsHistorico}
                                pagination={false}
                                rowKey="id"
                            />
                        </Col>
                    </MasterDetailForm>
                </Panel>
            </Collapse>
        </Visibility>
    );
};

export default WidgetDocuSignRelatorio;
